import clsx from 'clsx';
import type { ReactNode } from 'react';
import { UNSTABLE_Container } from '../container/container.js';
import { Stack } from '../spacing/stack/stack.js';
import { Text } from '../typography/text.js';

/** @internal */
export interface UNSTABLE_PageLayoutWithSidebarProps {
  children: ReactNode;
  isSidebarOpen?: boolean;
}

/** @internal */
export function UNSTABLE_PageLayoutWithSidebar({ children, isSidebarOpen }: UNSTABLE_PageLayoutWithSidebarProps) {
  return (
    <div className={clsx('cim-page-layout-with-sidebar')} data-sidebar-open={isSidebarOpen || undefined}>
      {children}
    </div>
  );
}

/** @internal */
export interface UNSTABLE_PageLayoutHeaderProps {
  title: string;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
}

/** @internal */
export function UNSTABLE_PageLayoutHeader({ title, breadcrumbs, actions }: UNSTABLE_PageLayoutHeaderProps) {
  return (
    <div className={clsx('cim-page-layout-header')}>
      <UNSTABLE_Container>
        <div className="cim-page-layout-header-breadcrumbs">{breadcrumbs}</div>
        <Stack direction="horizontal" gap={16} justify="space-between" align="center" marginTop={16} marginBottom={16}>
          <div className="cim-page-layout-header-title">
            <Text as="h1" variant="title-3">
              {title}
            </Text>
          </div>
          <div className="cim-page-layout-header-actions">{actions}</div>
        </Stack>
      </UNSTABLE_Container>
    </div>
  );
}

/** @internal */
export interface UNSTABLE_PageLayoutContentProps {
  children: ReactNode;
}

/** @internal */
export function UNSTABLE_PageLayoutContent({ children }: UNSTABLE_PageLayoutContentProps) {
  return <div className={clsx('cim-page-layout-content')}>{children}</div>;
}

/** @internal */
export interface UNSTABLE_PageLayoutSidebarProps {
  children: ReactNode;
}

/** @internal */
export function UNSTABLE_PageLayoutSidebar({ children }: UNSTABLE_PageLayoutSidebarProps) {
  return <div className={clsx('cim-page-layout-sidebar')}>{children}</div>;
}
